import { useEffect, useState } from 'react';
import { SCHOOL_SELECTION_EVENT } from '../services/schoolSelectionTtl';

const STORAGE_KEYS = {
  clsdk: 'clsdk_school_selection',
  clsse: 'clsse_school_selection',
  abcse: 'abcse_school_selection',
  clsfi: 'clsfi_school_selection',
};

/**
 * Read the currently-saved class name for a given brand slug from the same
 * localStorage entry the SchoolSelector writes to. Re-reads on the `storage`
 * event so cross-tab updates flow through. Returns null when nothing is
 * stored or no class has been picked yet.
 */
export default function useSchoolClass(brandSlug) {
  const key = STORAGE_KEYS[brandSlug] || null;
  const [className, setClassName] = useState(() => readClass(key));

  useEffect(() => {
    setClassName(readClass(key));
    if (!key) return undefined;
    const onStorage = (e) => {
      if (e.key === key) setClassName(readClass(key));
    };
    // `storage` only fires in other tabs — same-tab writes (the selector
    // popup) announce themselves via SCHOOL_SELECTION_EVENT.
    const onLocal = (e) => {
      if (!e.detail?.key || e.detail.key === key) setClassName(readClass(key));
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener(SCHOOL_SELECTION_EVENT, onLocal);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(SCHOOL_SELECTION_EVENT, onLocal);
    };
  }, [key]);

  return className;
}

function readClass(key) {
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.class || null;
  } catch {
    return null;
  }
}
